import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { data } from 'jquery';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PictureThePossibilitiesService {

  constructor(private http: HttpClient) { }

  public parentInitEvent: EventEmitter<void> = new EventEmitter<void>();


  acvtivitesDetail(): Observable<any> {
    const url = environment.apiURL + 'api/ptp/user-activities';
    return this.http.get(url);
  }

  getMoonshotRank(): Observable<any> {
    const url = environment.apiURL + 'api/admin/activity/1'
    return this.http.get(url);
  }
  getMoonshotDownload(part, userId): Observable<any> {
    const url = environment.apiURL + 'api/admin/activity/1/${part}/${userId}/files'
    return this.http.get(url);
  }

  postMoonshotScore(userId, postData: any): Observable<any> {
    const url = environment.apiURL + `api/admin/activity/1/${userId}/points`
    const data = postData
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post(url, data, {
      responseType: 'text',
      headers
    });
  }

  fileUpload(activityId,partId,file:File):Observable<any>{

    const formData = new FormData();
    formData.append('file', file);
    const url = environment.apiURL+`api/activity/${activityId}/${partId}`;
    return this.http.post(url,formData,
      {withCredentials: true,
      responseType:'text'
    });

  }

  fetchTalkJsMetadata(): Observable<any> {
    const url = environment.apiURL + 'api/talk-js-metadata';
    return this.http.get(url, { withCredentials: true });
  }
  fetchTalkJsMetadataPtp(): Observable<any> {
    const url = environment.apiURL + 'api/talk-js-metadata-ptp';
    return this.http.get(url, { withCredentials: true });
  }
  //PTP Circle APIs


  // APIs for PTP plaza started
  getPtpPlaza(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/ptp-plaza/info';
    return this.http.get(url, { withCredentials: true });
  }

  // Requests for Admin Updates

  postPlazaAdminPost(imageFile: File, postData: string): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/admin-post`;

    const formData = new FormData();
    formData.append('file_name', imageFile);

    let params: HttpParams = new HttpParams();
    params = params.set('ptpPlazaAdminPostDto', postData);
    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  postPlazaAdminComment(postData: string, id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/admin-post/${postData}/${id}`;

    const formData = new FormData();
    formData.append('comment', postData);
    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  deleteAdminPost(id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/admin-post/${id}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  deleteAdminPostComment(id: number, cmtId: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/admin-post/${id}/comments/${cmtId}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  // Requests for Creative Projects, Contests, and Challenges

  postCreativeContestProject(imageFile: File,postData: string): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/creative-work`;

    const formData = new FormData();
    formData.append('file_name', imageFile);

    let params: HttpParams = new HttpParams();
    params = params.set('ptpPlazaCreativeWorkDto', postData);
    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  deleteCreativeContestProject(id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/creative-work/${id}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  postCreativeContestComment(postData: string, id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/creative-work/${postData}/${id}`;

    const formData = new FormData();
    formData.append('comment', postData);
    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  deleteCreativeContestProjectComment(id: number, cmtId: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/creative-work/${id}/comments/${cmtId}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  // Requests for PTP Illuminations, Summits, and Other Events

  postIlluminationSummits(imageFile: File, postData: string): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/illumination`;

    const formData = new FormData();
    formData.append('file-name', imageFile);

    let params: HttpParams = new HttpParams();
    params = params.set('ptpPlazaIlluminationDto', postData);
    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  deleteIlluminationSummits(id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/illumination/${id}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }


  postPlazaIlluminationComment(postData: string, id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/illumination/${postData}/${id}`;

    const formData = new FormData();
    formData.append('comment', postData);
    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  deleteIlluminationSummitsComment(id: number, cmtId: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/illumination/${id}/comments/${cmtId}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }


  // Requests for All Things Creativity!

  postAllThingsCreativity(imageFile: File,postData: string): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/all-things-creativity`;

    const formData = new FormData();
    formData.append('file_name', imageFile);

    let params: HttpParams = new HttpParams();
    params = params.set('ptpPlazaAllThingsCreativityDto', postData);
    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  deleteAllThingsCreativity(id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/all-things-creativity/${id}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  postPlazaCreativityComment(postData: string, id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/all-things-creativity/${postData}/${id}`;

    const formData = new FormData();
    formData.append('comment', postData);
    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  deleteAllThingsCreativityComment(id: number, cmtId: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/ptp-plaza/all-things-creativity/${id}/comments/${cmtId}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }



  // APIs for PTP plaza ended



  // APIs for in-person and live events started


  // Illuminations

  getActiveUpcomingIllumination(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/in-person-events/active-upcoming-illumination';
    return this.http.get(url, { withCredentials: true });
  }

  getUpcomingIllumination(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/in-person-events/upcoming-illumination-list';
    return this.http.get(url, { withCredentials: true });
  }

  rsvpIllumination(id: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-person-events/upcoming-illumination/${id}/subscribe`;

    return this.http.post(url, {
      withCredentials: true,
      responseType: 'text'
    });
  }

  getIlluminationList(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/in-person-events/upcoming-illumination/subscriber-list';
    return this.http.get(url, { withCredentials: true });
  }

  addIlluminations(imageFile: File, imageName: string, thumbnailFile: File, thumbnailName: string, title: string, description: string, eventUrl: string, startDate: any, endDate: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-person-events/upcoming-illumination`;

    const formData = new FormData();
    formData.append('image', imageFile, imageName);
    formData.append('thumbnail', thumbnailFile, thumbnailName);

    let params: HttpParams = new HttpParams();
    params = params.set('title', title);
    params = params.set('description', description);
    params = params.set('eventUrl', eventUrl);
    params = params.set('startDate', startDate);
    params = params.set('endDate', endDate);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }


  activeIlluminations(id: any, active: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-person-events/upcoming-illumination/${id}`;

    const formData = new FormData();
    formData.append('id', id);

    let params: HttpParams = new HttpParams();
    params = params.set('isActive', active);
    return this.http.put(url, formData, {
      params: params,
      responseType: 'text'
    });
  }


  deleteIllumination(id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-person-events/upcoming-illumination/${id}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  editIllumination(id: any, fromData: FormData, postData: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-person-events/upcoming-illumination/${id}`;


    let params: HttpParams = new HttpParams();
    params = params.set('updateData', postData);
    return this.http.patch(url, fromData, {
      params: params,
      responseType: 'text',
      observe: 'response'
    });
  }


  //summits
  getActiveSummits(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/in-person-events/active-ptp-summit';
    return this.http.get(url, { withCredentials: true });
  }

  getSummits(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/in-person-events/ptp-summit-list';
    return this.http.get(url, { withCredentials: true });
  }

  rsvpSummits(id: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-person-events/ptp-summit/${id}/subscribe`;
    const formData = new FormData();
    formData.append('id', id);
    return this.http.post(url, {
      withCredentials: true,
      responseType: 'text'
    });
  }

  addSummits(imageFile: File, imageName: string, thumbnailFile: File, thumbnailName: string, title: string, description: string, eventUrl: string, startDate: any, endDate: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-person-events/ptp-summit`;

    const formData = new FormData();
    formData.append('image', imageFile, imageName);
    formData.append('thumbnail', thumbnailFile, thumbnailName);

    let params: HttpParams = new HttpParams();
    params = params.set('title', title);
    params = params.set('description', description);
    params = params.set('eventUrl', eventUrl);
    params = params.set('startDate', startDate);
    params = params.set('endDate', endDate);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  editSummit(id: any, formData: FormData, postData: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-persons-event/ptp-summit/${id}`;

    let params: HttpParams = new HttpParams();
    params = params.set('updateData', postData);
    return this.http.patch(url, formData, {
      params: params,
      responseType: 'text',
      observe: 'response'
    });
  }


  activeSummits(id: any, active: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-persons-event/ptp-summit/${id}`;

    const formData = new FormData();
    formData.append('id', id);

    let params: HttpParams = new HttpParams();
    params = params.set('isActive', active);
    return this.http.put(url, formData, {
      params: params,
      responseType: 'text'
    });
  }


  deleteSummits(id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/in-person-events/ptp-summit/${id}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }

  getSummitRsvpList(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/in-person-events/ptp-summit/subscriber-list';
    return this.http.get(url, { withCredentials: true });
  }

  // APIs for in-person and live events started


  // APIs for creativity contest and challenges


  // creatvity contest

  getActiveContestList(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/contest-challenges/active-creativity-contest-list';
    return this.http.get(url, { withCredentials: true });
  }

  getContestList(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/contest-challenges/creativity-contest-list';
    return this.http.get(url, { withCredentials: true });
  }

  addContest(imageFile: File, imageName: string, thumbnailFile: File, thumbnailName: string, title: string, description: string, startDate: any, endDate: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/creativity-contest`;

    const formData = new FormData();
    formData.append('image', imageFile, imageName);
    formData.append('thumbnail', thumbnailFile, thumbnailName);

    let params: HttpParams = new HttpParams();
    params = params.set('title', title);
    params = params.set('description', description);
    params = params.set('startDate', startDate);
    params = params.set('endDate', endDate);
    params = params.set('eventUrl', null);
    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }


  editContest(id: any, formData: FormData, postData: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/creativity-contest/${id}`;

    let params: HttpParams = new HttpParams();
    params = params.set('updateData', postData);
    return this.http.patch(url, formData, {
      params: params,
      responseType: 'text',
      observe: 'response'
    });
  }

  activateContest(id: any, active: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/creativity-contest/${id}`;

    const formData = new FormData();
    formData.append('id', id);

    let params: HttpParams = new HttpParams();
    params = params.set('isActive', active);
    return this.http.put(url, formData, {
      params: params,
      responseType: 'text'
    });
  }


  deleteContest(id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/creativity-contest/${id}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }


  addUserWorkContest(id: string, file: File, fileName: string, title: string, description: string): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/creativity-contest/${id}/user-work-contest`;

    const formData = new FormData();
    formData.append('id', id);
    formData.append('fileName', file, fileName);

    let params: HttpParams = new HttpParams();
    params = params.set('title', title);
    params = params.set('description', description);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }
  getWorkContestSubmissionList(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/contest-challenges/user-work-contest-list';
    return this.http.get(url, { withCredentials: true });
  }


  //challenges

  getActiveChallengesList(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/contest-challenges/active-challenges-list';
    return this.http.get(url, { withCredentials: true });
  }

  getChallengesList(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/contest-challenges/challenges-list';
    return this.http.get(url, { withCredentials: true });
  }

  addChallenges(imageFile: File, imageName: string, thumbnailFile: File, thumbnailName: string, title: string, description: string, startDate: any, endDate: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/challenge`;

    const formData = new FormData();
    formData.append('image', imageFile, imageName);
    formData.append('thumbnail', thumbnailFile, thumbnailName);

    let params: HttpParams = new HttpParams();
    params = params.set('title', title);
    params = params.set('description', description);
    params = params.set('startDate', startDate);
    params = params.set('endDate', endDate);
    params = params.set('eventUrl', null);
    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  editChallenge(id: any, formData: FormData, postData: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/challenge/${id}`;

    let params: HttpParams = new HttpParams();
    params = params.set('updateData', postData);
    return this.http.patch(url, formData, {
      params: params,
      responseType: 'text',
      observe: 'response'
    });
  }


  activateChallenge(id: any, active: any): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/challenge/${id}`;

    const formData = new FormData();
    formData.append('id', id);

    let params: HttpParams = new HttpParams();
    params = params.set('isActive', active);
    return this.http.put(url, formData, {
      params: params,
      responseType: 'text'
    });
  }


  deleteChallenge(id: number): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/challenge/${id}`;
    return this.http.delete(url, {
      withCredentials: true,
      responseType: 'text'
    })
  }


  addUserWorkChallenges(id: string, file: File, fileName: string, title: string, description: string): Observable<any> {
    const url = environment.apiURL + `api/ptp-circle/contest-challenges/challenge/${id}/user-work-challenge`;

    const formData = new FormData();
    formData.append('id', id);
    formData.append('fileName', file, fileName);

    let params: HttpParams = new HttpParams();
    params = params.set('title', title);
    params = params.set('description', description);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  getChallengeSubmissionList(): Observable<any> {
    const url = environment.apiURL + 'api/ptp-circle/contest-challenges/user-work-challenges-list';
    return this.http.get(url, { withCredentials: true });
  }

}
